/**
 * Calculates start and end times for a given number of days in the past
 * @param days - Number of days to look back from now
 * @returns Object containing start and end times in epoch seconds
 */
export const getTimeRangeInEpochSeconds = (days: number): { start: number; end: number } => {
  const millisecondsPerDay = 86400000 // 24 * 60 * 60 * 1000
  const now = Date.now()
  const startMs = now - days * millisecondsPerDay

  return {
    start: Math.floor(startMs / 1000), // Convert to epoch seconds
    end: Math.floor(now / 1000), // Convert to epoch seconds
  }
}

/**
 * Converts a time range string to epoch seconds based on TIME_RANGES constants
 * @param timeRange - Time range string (e.g., 'last_7_days', 'last_1_hour')
 * @returns Object containing start and end times in epoch seconds
 */
export const getTimeRangeFromString = (timeRange: string): { start: number; end: number } => {
  const now = Date.now()
  const currentDate = new Date(now)
  let startDate: Date
  let endDate: Date = new Date(now)

  switch (timeRange) {
    case 'last_5_minutes':
      startDate = new Date(now - 5 * 60 * 1000)
      break
    case 'last_15_minutes':
      startDate = new Date(now - 15 * 60 * 1000)
      break
    case 'last_30_minutes':
      startDate = new Date(now - 30 * 60 * 1000)
      break
    case 'last_1_hour':
      startDate = new Date(now - 60 * 60 * 1000)
      break
    case 'last_3_hours':
      startDate = new Date(now - 3 * 60 * 60 * 1000)
      break
    case 'last_6_hours':
      startDate = new Date(now - 6 * 60 * 60 * 1000)
      break
    case 'last_12_hours':
      startDate = new Date(now - 12 * 60 * 60 * 1000)
      break
    case 'last_24_hours':
      startDate = new Date(now - 24 * 60 * 60 * 1000)
      break
    case 'last_48_hours':
      startDate = new Date(now - 48 * 60 * 60 * 1000)
      break
    case 'last_7_days':
      startDate = new Date(currentDate)
      startDate.setDate(currentDate.getDate() - 7)
      break
    case 'last_30_days':
      startDate = new Date(currentDate)
      startDate.setDate(currentDate.getDate() - 30)
      break
    case 'last_60_days':
      startDate = new Date(currentDate)
      startDate.setDate(currentDate.getDate() - 60)
      break
    default:
      startDate = new Date(currentDate)
      startDate.setDate(currentDate.getDate() - 7)
  }

  return {
    start: Math.floor(startDate.getTime() / 1000),
    end: Math.floor(endDate.getTime() / 1000),
  }
}
